import { useEffect } from 'react';
import type React from 'react';

function useOnClickOutside(
  refs: Array<React.RefObject<HTMLDivElement | null>>,
  handler: (event: MouseEvent | TouchEvent) => void
) {
  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      // Si aucune des refs n'est définie ou que le clic est à l'intérieur de l'un des éléments, on ne fait rien
      if (refs.some(ref => ref.current && ref.current.contains(event.target as Node))) {
        return;
      }
      handler(event);
    };

    // Ajouter les écouteurs d'événements sur le document
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    // Nettoyer les écouteurs au démontage
    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [refs, handler]);
}

export default useOnClickOutside;
